(() => {
  function publish(eventName, data = {}) {
    if (!window.Shopify?.analytics?.publish) {
      console.warn(`[Tracking] Shopify Analytics indisponible : ${eventName}`);
      return;
    }

    window.Shopify.analytics.publish(`rodier:${eventName}`, data);
  }

  window.RodierTracking = { publish };

  // add_to_wishlist
  function observeWishlistButton(btn) {
    let wasActive =
      btn.classList.contains('wc_wishlistActive') ||
      btn.classList.contains('active') ||
      btn.classList.contains('isActive');

    new MutationObserver(() => {
      const isActive =
        btn.classList.contains('wc_wishlistActive') ||
        btn.classList.contains('active') ||
        btn.classList.contains('isActive');

      if (!wasActive && isActive) {
        const productId = (btn.id || '').replace('wcWishlist_', '');

        publish('add_to_wishlist', {
          item_id: productId,
          product_id: productId,
          currency: window.Shopify?.currency?.active || 'EUR'
        });
      }

      wasActive = isActive;
    }).observe(btn, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  document.querySelectorAll('.wc_wishlistBlock').forEach(observeWishlistButton);
  new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.('.wc_wishlistBlock')) observeWishlistButton(node);
        node.querySelectorAll?.('.wc_wishlistBlock').forEach(observeWishlistButton);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // stock_alert_subscribed
  function observeBisButton(btn) {
    btn.addEventListener('click', () => {
      const variantId = btn.dataset.variant_id || '';
      const productId = btn.dataset.product_id || '';
      const container = btn.closest('[class*="bis"], [class*="bsi"], [class*="back-in-stock"]') || btn.parentElement;

      const observer = new MutationObserver(() => {
        const success = container.querySelector('[class*="success"], [class*="confirm"], [class*="thank"]')
          || (btn.disabled)
          || btn.classList.contains('wc_bsi_subscribed')
          || btn.classList.contains('subscribed');

        if (success) {
          observer.disconnect();
          publish('stock_alert_subscribed', {
            item_id: variantId,
            product_id: productId
          });
        }
      });

      observer.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled'] });

      setTimeout(() => observer.disconnect(), 10000);
    }, { once: false });
  }

  document.querySelectorAll('.bis_product').forEach(observeBisButton);
  new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.('.bis_product')) observeBisButton(node);
        node.querySelectorAll?.('.bis_product').forEach(observeBisButton);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // select_item
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-track-select-item]');
    if (!link) return;

    publish('select_item', {
      item_id: link.dataset.variantId,
      product_id: link.dataset.productId,
      item_name: link.dataset.productName,
      price: Number(link.dataset.priceCents) / 100,
      currency: window.Shopify?.currency?.active || 'EUR',
      item_list_name: link.dataset.listName || '',
      index: Number(link.dataset.index || 0)
    });
  });
})();